import {differenceInCalendarDays} from "date-fns";
import * as lscache from "lscache";

import {ICreditOffersFilters} from "../types/ICreditOffersFilters";

const CREDIT_FILTERS = "creditFilters";

export const getCreditFiltersStorage = (): ICreditOffersFilters => {
    const filtersStorage = lscache.get(CREDIT_FILTERS);
    const today = new Date();

    if (filtersStorage?.timeStamp && differenceInCalendarDays(today, filtersStorage?.timeStamp) >= 31) {
        return {} as ICreditOffersFilters;
    }
    return filtersStorage?.filters || {};
};

export const setCreditFiltersStorage = (filters: ICreditOffersFilters): void => {
    const timeStamp = new Date();

    lscache.set(CREDIT_FILTERS, {
        filters,
        timeStamp
    });
};
import {differenceInCalendarDays} from "date-fns";
import * as lscache from "lscache";

import {ICreditOffersFilters} from "../types/ICreditOffersFilters";

const CREDIT_FILTERS = "creditFilters";

export const getCreditFiltersStorage = (): ICreditOffersFilters => {
    const filtersStorage = lscache.get(CREDIT_FILTERS);
    const today = new Date();

    if (filtersStorage?.timeStamp && differenceInCalendarDays(today, filtersStorage?.timeStamp) >= 31) {
        return {} as ICreditOffersFilters;
    }
    return filtersStorage?.filters || {};
};

export const setCreditFiltersStorage = (filters: ICreditOffersFilters): void => {
    const timeStamp = new Date();

    lscache.set(CREDIT_FILTERS, {
        filters,
        timeStamp
    });
};
